<template>
  <div class="n7">
    <div class="step-img-wrapper">
      <img src="@/assets/images/fw_bg.jpg" width="100%" height="100%" style="object-fit: cover;" alt="应用案例"/>

      <div class="consult">
        <tiny-button type="warning" size="large">立即咨询 {{ phone }}
        </tiny-button>
      </div>
    </div>
  </div>
</template>

<script>
import {Button} from '@opentiny/vue'

export default {
  name: "HomePart7",
  components: {
    TinyButton: Button,
  },
  props:['phone'],
  data() {
    return {

    };
  },
  methods: {

  },
  
};
</script>

<style scoped>

.step-img-wrapper {
  height: 320px;
  position: relative;
}




.consult {
  position: absolute;
  bottom: 50px;
  margin: 0 auto;
  width: 100%;
  text-align: center;
}

.clause {
  position: absolute;
  right: 50px;
  bottom: 50px;
}

</style>


